import React from 'react';
import Icon from './Icon';

const Notification = ({ notification }) => {
  if (!notification) return null;

  const isSuccess = notification.type === 'success';

  return (
    <div
      className="absolute top-4 left-4 right-4 z-[999] animate-fadeUp"
      style={{ animationFillMode: 'forwards' }}
    >
      <div
        className={`
          flex items-center gap-3 px-4 py-3.5 rounded-2xl
          shadow-2xl border backdrop-blur-xl
          ${isSuccess
            ? 'bg-emerald-500/15 border-emerald-500/25 text-emerald-400'
            : 'bg-rose-500/15 border-rose-500/25 text-rose-400'}
        `}
      >
        <Icon name={isSuccess ? 'check' : 'x'} size={16} />
        <p className="text-sm font-dm font-medium text-white">{notification.msg}</p>
      </div>
    </div>
  );
};

export default Notification;
